import {
  REQUEST_LOADING,
  REQUEST_FAILURE,
  REQUEST_SUCCESS,
  RESET_REQUEST_STATE,
  OPEN_KNOWLEDGE_CENTER,
  CLOSE_KNOWLEDGE_CENTER,
  KNOWLEDGE_CENTER_STATE_KEY,
  OPEN_CONTRACT_ID_EDITOR,
  CLOSE_CONTRACT_ID_EDITOR,
  CONTRACT_ID_SELECTION_APPLIED,
} from '../actionTypes';
import type {
  ContractIdSelectionAppliedPayload,
  OpenContractIdEditorPayload,
} from '@src/CommonComponents/ContractIdFilter/contractIdEditor.types';

export const setRequestLoading = (payload: unknown, key: string) => ({
  type: REQUEST_LOADING,
  key,
  payload,
});
export const setRequestError = (payload: unknown, key: string) => ({
  type: REQUEST_FAILURE,
  key,
  payload,
});
export const setRequestSuccess = (payload: unknown, key: string) => ({
  type: REQUEST_SUCCESS,
  key,
  payload,
});

// Action to reset/clear specific request state keys
export const resetRequestState = (keys: string[]) => ({
  type: RESET_REQUEST_STATE,
  payload: keys,
});

export const openKnowledgeCenter = (
  metricData: unknown,
  key: string = KNOWLEDGE_CENTER_STATE_KEY
) => ({
  type: OPEN_KNOWLEDGE_CENTER,
  key,
  payload: {
    isOpen: true,
    metricData: metricData || {},
  },
});

export const closeKnowledgeCenter = (key: string = KNOWLEDGE_CENTER_STATE_KEY) => ({
  type: CLOSE_KNOWLEDGE_CENTER,
  key,
  payload: {
    isOpen: false,
    metricData: {},
  },
});

export const openContractIdEditor = (payload: OpenContractIdEditorPayload) => ({
  type: OPEN_CONTRACT_ID_EDITOR,
  payload,
});

export const closeContractIdEditor = () => ({
  type: CLOSE_CONTRACT_ID_EDITOR,
});

export const contractIdSelectionApplied = (payload: ContractIdSelectionAppliedPayload) => ({
  type: CONTRACT_ID_SELECTION_APPLIED,
  payload,
});
